import { render, staticRenderFns } from "./balanceDynamic.vue?vue&type=template&id=32371417"
import script from "./balanceDynamic.vue?vue&type=script&lang=ts"
export * from "./balanceDynamic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports